module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAABTElEQVQ4ja3UsUtbQRwH8I+PgDwqQilIRzuYwQypW4Njhgyh9B8oTo4ZHDqVgugmmCEu9Q9w8Q8ImEBpp1Roh4I4lA6lLeLULg4JHcThJfKI7/muoV94cNzd73Pccffmanuf3JPHWMcCfmGAUXpCY9i9bZdykEUcYANzqf7feIPDrKIs7AE+YC1j7BHeYgm704NRRsHrHCidbVRCsM0CaFL3sgh7KNlCSFaKsGEglDl3GhvhYyD2vgiDnQDoG45CsB62cJ0D/cBz/A3BoINnOMYFrnAmuVtP8TWrKO8FVLCK0/GXzgt8xnkRVsf+ePWifMErvJt0pLfZQj8QMp7X78XN1jRWl5xT3hnmJUKnFzfraaw9A5QG25NGGdUZoUmqvbhZjmS8/hlTiRD/JyyOcOLuXfrXDNAv4Q9qWMYTyX9/PgAY4RLfG8PuT7gB1ME5VpzcNdsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/img/event/十万.png
// module id = 1M2r
// module chunks = 32